/**
 * Quick math's answer feedback, shared by web and mobile. A right answer lights up at once.
 * A wrong one first stays on its own, greyed out and with a small shake, so the person sees
 * what they picked; only after `WRONG_ANSWER_REVEAL_MS` does the right one light up, with
 * "So close". Showing the right answer the instant the wrong one was tapped read as the tap
 * having landed on the right one.
 */
export const WRONG_ANSWER_REVEAL_MS = 1000;

/** How an option looks once an answer is picked: lit (the right answer), greyed out (a wrong pick), or as it was. */
export type AnswerLook = 'idle' | 'right' | 'wrong';

export interface AnswerState {
  /** The option the person tapped; `null` before they have. */
  picked: number | string | null;
  correct: number | string;
  /** A wrong pick's reveal delay has passed (a right pick needs none). */
  revealed: boolean;
}

/** Whether the right answer and the feedback line show yet. */
export function answerShown({ picked, correct, revealed }: AnswerState): boolean {
  return picked !== null && (picked === correct || revealed);
}

export function answerLook(option: number | string, state: AnswerState): AnswerLook {
  if (state.picked === null) return 'idle';
  if (option === state.correct) return answerShown(state) ? 'right' : 'idle';
  return option === state.picked ? 'wrong' : 'idle';
}
